import React from "react";
import { connect } from "react-redux";
import { Popup, Button, } from "devextreme-react";
import {
  openCloseModalDelRoles,
  setSelectedTab,
  setLoadingResumeData,
  openCloseSelectRoles,
  loading,
  doDelRolesTrabajador,
} from "./actions";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";

class ModalDelRoles extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  componentWillUnmount = () => {
    this.props.dispatch(openCloseSelectRoles(false));
  };

  handleCerrar = () => {
    this.props.dispatch(openCloseModalDelRoles(false, {}));
    this.props.dispatch(setLoadingResumeData({}));
    this.props.dispatch(setSelectedTab(this.props.sectionTabs[0]));
    this.props.dispatch(loading(false));
  };


  handleDeleteRoles = () => {
    const data = { companyRut: this.props.companyId, rut: this.props.selectedTrabajador.Rut, employeeName: this.props.selectedTrabajador.EmployeeName}
    this.props.dispatch(doDelRolesTrabajador(data));
    this.handleCerrar();
  }

  render() {
    return (
      <Popup
        visible={this.props.isOpenModalDelRoles}
        onHiding={this.handleCerrar}
        dragEnabled={false}
        height={250}
        width={600}
        showTitle={true}
        showCloseButton
        closeOnOutsideClick
        contentComponent={() => (
          <div>
              <div
              style={{
                position: "absolute",
                left: 20,
                right: 20,
                marginTop: -10,
              }}
            >
              {this.props.isLoading && <LoadingOverlay />}
              <div className="modal-del-rol">
                <h5>Estás a punto de eliminar a {this.props.selectedTrabajador.EmployeeName}</h5>
              <p>¿Está seguro que deseas desasociar al usuario {this.props.selectedTrabajador.EmployeeName} de la empresa que administras?</p>
              </div>
            </div>
            <div className="button-row">
              <div>
                <Button text="No, cancelar" onClick={this.handleCerrar} />
              </div>
              <div>
                <Button
                  text="Eliminar usuario"
                  type="danger"
                  onClick={this.handleDeleteRoles}
                />
              </div>
            </div>
          {/* <ModalSuccess open={this.state.isSuccess}/> */}
          </div>
        )}
      />

    );
  }
}

const mapStateToProps = (state) => ({
  userData: state.global.userData,
  companyId: state.global.companyId?.toLowerCase(),
  roles: state.asignacionRoles.roles,
  isOpenModalEditarRoles: state.asignacionRoles.isOpenModalEditarRoles,
  isOpenModalDelRoles: state.asignacionRoles.isOpenModalDelRoles,
  selectedTrabajador: state.asignacionRoles.selectedTrabajador,
  isLoading: state.asignacionRoles.isLoading,
  sectionTabs: state.asignacionRoles.sectionTabs,
  selectedTab: state.asignacionRoles.selectedTab,
  gruposPortalEmpresa: state.asignacionRoles.gruposPortalEmpresa,
  isOpenSelectRoles: state.asignacionRoles.isOpenSelectRoles,
  allRoles: state.mantenedores.roles,
  userProfiles: state.global.userProfiles,
  myCompanyRoles: state.global.myCompanyRoles,
  myCompanyProfiles: state.global.myCompanyProfiles,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalDelRoles);
